module.exports = __webpack_public_path__ + "img/ball_6.9a5cb310.png";